<template>
<div class="page">
  <div class="contents">
    <div v-if="artist" :data-artist="artist.slug">
      <div class="row" v-if="artist.show_action">
        <div class="col"><div class="inner">
          <h2 class="heading size-large">{{artist.num|pad}}, {{artist.title}}</h2>

          <div class="details size-body">
            <div v-if="artist.dates">Dates: {{artist.dates}}</div>
            <div v-else>Dates: {{artist.num|numDate}}</div>
            <div v-if="artist.location">Location: {{artist.location}}</div>
            <div v-if="artist.commissioned_by">Commissioned By: {{artist.commissioned_by}}</div>
            <div v-if="artist.thanks_to">With thanks to: {{artist.thanks_to}}</div>
            <div v-if="artist.medium">Medium: {{artist.medium}}</div>
            <div>Location: <span v-if="artist.city">{{artist.city}},</span> {{artist.country}}</div>
          </div>
        </div></div>

        <div class="col text size-body"><div class="inner" v-html="$options.filters.markdown(artist.work)"></div></div>
      </div>

      <artist-gallery class="gallery" v-if="artist.show_action && artist.gallery && artist.gallery.length" :gallery="artist.gallery"></artist-gallery>

      <div class="row">
        <div class="col"><div class="inner">
          <div v-if="artist.show_action">
            <h3 class="size-large">Artist Information</h3>
          </div>
          <div v-else>
            <h2 class="size-large">{{artist.num|pad}}, {{artist.title}}</h2>

            <div class="details size-body">
              <div>Date: {{artist.num|numDate}}</div>
              <div v-if="artist.medium">Medium: {{artist.medium}}</div>
              <div>Location: <span v-if="artist.city">{{artist.city}},</span> {{artist.country}}</div>
            </div>
          </div>

          <div class="details size-body">
            <div v-if="artist.country_birth">Born: {{artist.country_birth}}</div>
            <div v-if="artist.lives">Lives: {{artist.lives}}</div>
            <div v-if="artist.identifies_as">Identifies as: {{artist.identifies_as}}</div>
            <div v-if="artist.language_group">Language/Language group: {{artist.language_group}}</div>
            <div v-if="artist.website">Website: {{artist.website}}</div>
            <div v-if="artist.instagram">Instagram: <a target="_blank" :href="`https://instagram.com/${artist.instagram}`">@{{artist.instagram}}</a></div>
          </div>
        </div></div>

        <div class="col text size-body"><div class="inner" v-html="$options.filters.markdown(artist.about)"></div></div>
      </div>

      <div class="row" v-if="artist.previous_works && artist.previous_works.length">
        <div class="col"><div class="inner">
          <h2 class="size-large">Previous Works</h2>
        </div></div>
        <div class="col text size-body"><div class="inner">
          <div v-for="(row, n) in artist.previous_works" :key="n" :data-n="n">
            <div v-if="row.text" v-html="$options.filters.markdown(row.text)"></div>
            <figure v-if="row.image || row.video">
              <img :src="$options.filters.imgix(row.image, { w: 1200, fit: 'max' })" v-if="row.image" />
              <video-player v-if="row.video" :src="row.video"></video-player>
              <figcaption class="size-tiny" v-if="row.caption" v-html="$options.filters.markdown(row.caption)"></figcaption>
            </figure>
          </div>
        </div></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import fitvids from 'fitvids'

export default Vue.component('RouteArtist', {
  mounted() {
    fitvids()
  },
  watch: {
    artist(to, from) {
      if(!from && to) {
        this.$nextTick(() => {
          fitvids()
        })
      }
    }
  },
  computed: {
    slug() {
      return this.$route.params.artist
    },
    artist() {
      return _.find(this.$store.getters['artists/artists'], { slug: this.slug })
    }
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.page {
  background: transparentize($color-white, 0.02)!important;
  min-height: 100vh;
  padding-top: 9.6rem;
  float: left;
  padding-bottom: 4.8rem;
  width: 100vw;
}

/deep/ .fluid-width-video-wrapper {
  margin-bottom: 1.4rem;
}

.row {
  display: flex;
  @media (max-width: $break-small) {
    display: block;
  }
  .col {
    width: calc(100% * 1 / 2);
    @media (max-width: $break-small) {
      width: 100%;
    }
    .inner {
      padding: $gutter;
      @media (max-width: $break-small) {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &.text .inner {
      padding: $gutter;
      @media (min-width: #{$break-small + 1px}) {
        padding-left: 0;
      }
      @media (max-width: $break-small) {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
}

.text {
  @media (min-width: #{$break-small + 1px}) {
    [data-n="0"] /deep/ {
      h2 {
        margin-top: 6.4rem;
      }
    }
  }
  /deep/ {
    h2 {
      @media (min-width: #{$break-small + 1px}) {
        position: absolute;
        left: $gutter;
        width: 30%;
      }
      text-transform: uppercase;
      margin-bottom: $gutter;
    }
    figure {
      margin-bottom: $gutter;
      img {
        max-width: 100%;
        margin-bottom: $size-tiny;
      }
      video {
        margin-bottom: $size-tiny;
      }
    }
    figcaption {
      font-family: $font-mono;
      font-weight: normal;
      text-transform: uppercase;
      color: $color-gray;
    }
  }
}

h2, h3 {
  margin-bottom: $gutter;
  line-height: 1;
  text-transform: uppercase;
}

@media (max-width: $break-small) {
  h2:not(.heading), h3 {
    padding-top: 4.8rem;
  }
}

.details {
  text-transform: uppercase;
  margin-bottom: 4.8rem;
  max-width: 52rem;
}
.gallery {
  margin: 9.6rem 0;
  @media (max-width: $break-small) {
    margin: 0;
  }
}
[data-artist="hera-bueyuektasciyan"] .gallery {
  margin-bottom: 20rem;
}
</style>


// WEBPACK FOOTER //
// src/routes/route-artist.vue